import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { useState, useCallback } from 'react';
import { getSelectedOrDefaultCountry } from './utils.js';
import { usePrevious } from '../utils/hooks/usePrevious.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useControlledPhoneInput = function useControlledPhoneInput(dialingCodeProp) {
  var localPhoneNumberProp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var items = arguments.length > 2 ? arguments[2] : undefined;
  var onChangeProp = arguments.length > 3 ? arguments[3] : undefined;
  var isControlled = dialingCodeProp !== undefined && onChangeProp !== undefined;
  var _useState = useState(function () {
      return _objectSpread({
        localPhoneNumber: localPhoneNumberProp
      }, getSelectedOrDefaultCountry(items, dialingCodeProp));
    }),
    _useState2 = _slicedToArray(_useState, 2),
    phoneNumber = _useState2[0],
    setPhoneNumber = _useState2[1];
  var prevPropValue = usePrevious(phoneNumber);
  var onChange = useCallback(function (phoneNumber) {
    onChangeProp === null || onChangeProp === undefined || onChangeProp(phoneNumber);
    if (!isControlled) {
      setPhoneNumber(phoneNumber);
    }
  }, [onChangeProp, setPhoneNumber, isControlled]);
  if (isControlled && (localPhoneNumberProp !== prevPropValue.localPhoneNumber && localPhoneNumberProp !== phoneNumber.localPhoneNumber || dialingCodeProp !== prevPropValue.dialingCode && dialingCodeProp !== phoneNumber.dialingCode)) {
    setPhoneNumber(_objectSpread({
      localPhoneNumber: localPhoneNumberProp
    }, getSelectedOrDefaultCountry(items, dialingCodeProp)));
  }
  return {
    phoneNumber: phoneNumber,
    onChange: onChange
  };
};

export { useControlledPhoneInput };
